import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback, useState } from 'react';
import { createRecordStatOutbound } from '../../api/outbound/commonOutbounds';
import { isConfigFlagEnabled } from '../../config';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../redux/store';
import { MESSAGE_BOX_RED_FONT_REPLACEMENT_COLOR } from '../../styles/colors';
import { HtmlRenderer } from '../htmlAreas/htmlRenderer';
import { OpenModalContainer } from '../openModalContainer';
export const TourneySummaryModal = ({ title, html, winnerName, shareWinMessage, onClose }) => {
    const isWinner = useAppSelector((state) => state.selfData.username === winnerName);
    const socketSend = useSocketSend();
    const [isCopied, setIsCopied] = useState(false);
    const onClickShare = useCallback(() => {
        socketSend(createRecordStatOutbound('TOURNEY_WIN_SHARES'));
        const shareData = { text: shareWinMessage };
        if (!navigator.canShare || !navigator.canShare(shareData)) {
            // can't use share API, so copy to clipboard
            navigator.clipboard.writeText(shareData.text);
            setIsCopied(true);
        }
        else {
            navigator.share(shareData);
        }
    }, [shareWinMessage, socketSend]);
    const label = isCopied ? 'COPIED!' : 'Share Your Win';
    // TODO: Consider requiring a click on a 'Close' button when the share button is present so the user is more likely to
    // share, since they can't as easily, or accidentally, close the modal before sharing.
    return (_jsx(OpenModalContainer, { title: title, onClose: onClose, maxWidth: 'md', children: _jsxs(DialogContent, { children: [_jsx(DialogContentText, { children: _jsx(HtmlRenderer, { html: html, fontColorReplacements: { '#550000': MESSAGE_BOX_RED_FONT_REPLACEMENT_COLOR } }) }), isConfigFlagEnabled('tourneyWinSharing') && isWinner ? (_jsx(DialogContentText, { children: _jsx(Button, { variant: 'contained', onClick: onClickShare, startIcon: isCopied ? _jsx(AssignmentTurnedInRoundedIcon, {}) : _jsx(IosShareRoundedIcon, {}), children: label }) })) : null] }) }));
};
